import MobileInstructions from './MobileInstructions';

export default MobileInstructions;